


























































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as calc from '@/app/order-calculations-interface';
import { GQL_order_order } from '@/queries/__generated__/order';
import i18n from '@/i18n';
import Decimal from '@/utils/decimal';
import { GQL_newInvoiceData_newInvoice } from '@/queries/__generated__/newInvoiceData';
import formatAmount from '@/filters/formatAmount';

@Component
export default class DocumentSummary extends Vue {
  @Prop(Object) public document!: GQL_order_order | GQL_newInvoiceData_newInvoice;
  @Prop(Array) taxSubtotals!: calc.IOrderTaxSubtotal[];

  get summaryRows()  {
    const summaries = this.taxSubtotals.map(subtotal => {
      return {
        rowTitle: `${formatAmount(subtotal.taxPercent)}%`,
        taxableAmount: subtotal.taxableAmount,
        taxAmount: subtotal.taxAmount,
        taxInclusiveAmount: subtotal.taxInclusiveAmount,
      };
    });

    if (!this.roundingAmount.equals(0)) {
      summaries.push(
        {
          rowTitle: i18n.t('Document.rounding').toString(),
          taxableAmount: this.roundingAmount,
          taxAmount: new Decimal(0),
          taxInclusiveAmount: this.roundingAmount,
        },
      );
    }

    return summaries;
  }

  get roundingAmount(): Decimal {
    if (!('payableRoundingAmount' in this.document)) return new Decimal(0);

    return this.document.payableRoundingAmount;
  }
}
